import saunaBnbCakeLpFarmingSaltSauna from "../abis/production/saunaBnb/pools/saltSauna";
import saunaBnbCakeLpFarmingBarrelSauna from "../abis/production/saunaBnb/pools/barrelSauna";
import saunaBnbCakeLpFarmingSmokeSauna from "../abis/production/saunaBnb/pools/smokeSauna";

const host = "https://bscscan.com/address";
const swapHost = "https://pancakeswap.finance/add";
const pairHost = "https://pancakeswap.info/pool";

export default [
  {
    title: "Salt Sauna",
    temperature: 30,
    type: "bnb",
    contractAddress: "0x5e5aa79fe5e9f35fdd2e25750636a5bf243a0caf",
    minApr: 159,
    abi: saunaBnbCakeLpFarmingSaltSauna.abi,
    url: `${host}/0x5e5aa79fe5e9f35fdd2e25750636a5bf243a0caf`,
    swapUrl: `${swapHost}/BNB/0x06b889a7a7fa15D8cC7CFf147962C4232cCE7CF0`,
    pairUrl: `${pairHost}/0x555808d7e7b82b9beef6388b65e1d98cf6069f75`,
  },
  {
    title: "Barrel Sauna",
    temperature: 30,
    type: "bnb",
    contractAddress: "0x24e598c38d5feee58ddd550e64a19a3fe20a943a",
    minApr: 159,
    abi: saunaBnbCakeLpFarmingBarrelSauna.abi,
    url: `${host}/0x24e598c38d5feee58ddd550e64a19a3fe20a943a`,
    swapUrl: `${swapHost}/BNB/0x06b889a7a7fa15D8cC7CFf147962C4232cCE7CF0`,
    pairUrl: `${pairHost}/0x555808d7e7b82b9beef6388b65e1d98cf6069f75`,
  },
  {
    title: "Smoke Sauna",
    temperature: 30,
    type: "bnb",
    contractAddress: "0x1135f3821e73b1511f208f661199665365959a04",
    minApr: 159,
    abi: saunaBnbCakeLpFarmingSmokeSauna.abi,
    url: `${host}/0x1135f3821e73b1511f208f661199665365959a04`,
    swapUrl: `${swapHost}/BNB/0x06b889a7a7fa15D8cC7CFf147962C4232cCE7CF0`,
    pairUrl: `${pairHost}/0x555808d7e7b82b9beef6388b65e1d98cf6069f75`,
  },
];

// Information of Farming pools is as follows
// ━━━━━━━━━━━━━━

// ■Pancake LPLöyly Farming

// Name：Salt Sauna

// Stake. SAUNA - BNB Cake LP
// Earn. SAUNA
// Total Reword Token: 1825k (SAUNA)
// Start Time: now
// Bonus End Time:now→1825days
// Min. Cake LP Token:  250Cake-LP（SAUNA-BNB）
// Max. Total SAUNA Token:  No specification
// Unstake time lock. 45days
// Unstake Fee. 30%

// *Unstake time lock will be reset only when staking is done manually.

// ━━━━━━━━━━━━━━

// ■Pancake LPLöyly Farming

// Name：Barrel Sauna

// Stake. SAUNA - BNB Cake LP
// Earn. SAUNA
// Total Reword Token:  2281k (SAUNA)
// Start Time: now
// Bonus End Time:now→1825days
// Min. Cake LP Token:  400Cake-LP（SAUNA-BNB）
// Max. Total SAUNA Token:  No specification
// Unstake time lock. 90days
// Unstake Fee. 30%

// *Unstake time lock will be reset only when staking is done manually.

// ━━━━━━━━━━━━━━

// ■Pancake LPLöyly Farming

// Name：Smoke Sauna

// Stake. SAUNA - BNB Cake LP
// Earn. SAUNA
// Total Reword Token:  2738k (SAUNA)
// Start Time: now
// Bonus End Time:now→1825days
// Min. Cake LP Token:  No specification
// Max. Total SAUNA Token:  800Cake-LP（SAUNA-BNB）
// Unstake time lock. 135days
// Unstake Fee. 30%

// *Unstake time lock will be reset only when staking is done manually.

// ━━━━━━━━━━━━━━
